import {
  AdminLayout,
  LinkedSourcePicker,
  useImmerState,
  useServiceStore,
  useSource,
  useTranslation,
} from "@opendash/core";
import { DataSelect } from "@opendash/plugin-timeseries";
import { AdminToolbar } from "@opendash/ui";
import { Button, Modal } from "antd";
import * as React from "react";
import {
  AlarmCreate,
  AlarmList,
  useAlarmModal,
  useMonitoringService,
} from "..";

export const AlarmManagementRoute = React.memo(function AlarmManagementRoute() {
  const t = useTranslation();

  const monitoring = useMonitoringService();

  const [state, updateState, setState, assignToState] = useImmerState({
    create: false,
    createItem: null,
    createItemDimension: 0,
    step: 1, // Hinzugefügter Schritt-State
    searchString: "",
  });

  const [source] = useSource();

  const allAlarms = useServiceStore(
    monitoring,
    React.useCallback((state) => state.alarms, [])
  );

  const alarms = React.useMemo(() => {
    return allAlarms.filter((alarm) => {
      const [sourceId] = alarm.item;

      return sourceId === source?.tag;
    });
  }, [allAlarms, source]);

  const [, openModal] = useAlarmModal();

  const handleNext = () => {
    assignToState({ step: 2 });
  };

  const handleBack = () => {
    assignToState({ step: 1 });
  };

  const handleCreate = () => {
    assignToState({
      create: false,
      createItem: null,
      createItemDimension: 0,
      step: 1,
    });
  };

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("opendash:monitoring.alarms.management_title")}
        description={t("opendash:monitoring.alarms.management_description")}
        actions={[
          <Button
            key="create"
            type="primary"
            title={t("opendash:monitoring.alarms.create.action_desc")}
            onClick={() => assignToState({ create: true, step: 1 })}
          >
            {t("opendash:monitoring.alarms.create.action")}
          </Button>,
        ]}
        children={<LinkedSourcePicker style={{ width: "100%" }} />}
      />

      <div className="od-page-main">
        <AlarmList alarms={alarms} />
      </div>

      <Modal
        open={!!state.create}
        width={600}
        title={t("opendash:monitoring.alarms.create.modal_title")}
        cancelText={t("opendash:ui.back")} // "Abbrechen" zu "Zurück" geändert
        onCancel={() =>
          assignToState({
            create: false,
            createItem: null,
            createItemDimension: 0,
            step: 1,
          })
        }
        cancelButtonProps={{ style: { display: "none" } }}
        okText={state.step === 1 ? t("opendash:ui.next") : t("opendash:ui.end")} // "Speichern" zu "Beenden" geändert
        okButtonProps={{
          disabled: !state.createItem && state.step === 1,
        }}
        onOk={() => {
          if (state.step === 1) {
            handleNext();
          } else {
            handleCreate();
          }
        }}
        styles={{ body: { padding: 20 } }}
      >
        {state.step === 1 && (
          <DataSelect
            selectionOptions={{
              select: "dimension",
              max: 1,
              min: 1,
            }}
            selection={
              state.createItem
                ? [
                    [
                      state.createItem?.source,
                      state.createItem?.id,
                      state.createItemDimension,
                    ],
                  ]
                : []
            }
            onSelection={(keys, items, dimensions) => {
              assignToState({
                createItem: items[0],
                createItemDimension: dimensions[0],
              });
            }}
          />
        )}
        {state.step === 2 && (
          <>
            <AlarmCreate
              item={state.createItem}
              dimension={state.createItemDimension}
              onSave={() => {
                assignToState({
                  create: false,
                  createItem: null,
                  createItemDimension: 0,
                  step: 1,
                });
              }}
            />
          </>
        )}
      </Modal>
    </AdminLayout>
  );
});
